import ReloadButton from "../components/ReloadButton";

const TitleWithReloadButton = ({ title }) => {
    return (
        <div className="title-with-reload-button">
                <h2>{title}</h2>
                <ReloadButton />
        </div>
    )
}

export default TitleWithReloadButton;